// Omnix/common/schemas/collections/omniTicketUpdateTemplates.js
import { z } from "zod";

const OmniTicketUpdateTemplateSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this template belongs to."),
    
    eventType: z.enum(['statusChange', 'assignmentChange']).describe("The event that triggers this template."),
    
    // e.g., for statusChange, this could be 'solved', 'closed', etc.
    // For assignmentChange, this might be null or a specific team ID.
    eventSubType: z.string().optional().nullable().describe("A more specific trigger, like a particular status."),
    
    channelType: z.string().describe("The channel this template applies to (e.g., 'email', 'sms', 'whatsapp'). 'all' for any channel."),
    
    templateBody: z.string().min(1).describe("The message body, with Mustache placeholders like {{ticketNumber}}, {{newStatus}}, {{assigneeName}}."),
    
    isEnabled: z.boolean().default(true),
});

export default OmniTicketUpdateTemplateSchema;